export enum TaskSortingTypes {
    STARTED = 'start',
    DEADLINE = 'deadline',
}
